import { Skeleton } from "@/components/ui/skeleton";

// Esqueleto de carga para el detalle de una unidad (público y portal).
export const UnidadDetalleSkeleton = () => (
  <div data-testid="unidad-detalle-skeleton">
    <Skeleton className="h-5 w-32" />

    <div className="mt-6 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-6">
      <div className="flex items-center gap-4">
        <Skeleton className="h-12 w-12 shrink-0 rounded-[var(--tc-radius)]" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-3 w-32" />
        </div>
        <Skeleton className="hidden h-7 w-28 shrink-0 rounded-full sm:block" />
      </div>
    </div>

    <div className="mt-5 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-6">
      <Skeleton className="h-3 w-28" />
      <div className="mt-6 flex flex-col gap-5 lg:flex-row lg:items-start lg:gap-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 lg:flex-1 lg:flex-col lg:gap-2">
            <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
            <Skeleton className="h-3 w-24 lg:w-16" />
          </div>
        ))}
      </div>
    </div>

    <div className="mt-5 grid gap-5 lg:grid-cols-2">
      {[0, 1].map((i) => (
        <div key={i} className="rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-6">
          <Skeleton className="h-3 w-28" />
          <div className="mt-4 space-y-3">
            {Array.from({ length: 5 }).map((_, j) => (
              <Skeleton key={j} className="h-4 w-full" />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
